module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Maps"
    }
  }, [_c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "map_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("The British Sector on the Aisne, 27 May 1918.")])])]), _c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "map_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_5.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("British Divisions, 27 May.")])])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be50b488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Maps.vue
// module id = 75
// module chunks = 0